export default [
  {
    County: 'Blekinge län',
    Latitude: 56.283333,
    Longitude: 15.116667
  },
  {
    County: 'Dalarnas län',
    Latitude: 60.678611,
    Longitude: 15.600556
  },
  {
    County: 'Gotlands län',
    Latitude: 57.5,
    Longitude: 18.5
  },
  {
    County: 'Gävleborgs län',
    Latitude: 60.780556,
    Longitude: 16.655278
  },
  {
    County: 'Hallands län',
    Latitude: 56.75,
    Longitude: 13
  },
  {
    County: 'Jämtlands län',
    Latitude: 63,
    Longitude: 14.666667
  },
  {
    County: 'Jönköpings län',
    Latitude: 57.75,
    Longitude: 14.2
  },
  {
    County: 'Kalmar län',
    Latitude: 56.733333,
    Longitude: 15.9
  },
  {
    County: 'Kronobergs län',
    Latitude: 56.79,
    Longitude: 14.44
  },
  {
    County: 'Norrbottens län',
    Latitude: 67,
    Longitude: 20
  },
  {
    County: 'Skåne län',
    Latitude: 56,
    Longitude: 13.45
  },
  {
    County: 'Stockholms län',
    Latitude: 59.333333,
    Longitude: 18.166667
  },
  {
    County: 'Södermanlands län',
    Latitude: 58.771111,
    Longitude: 16.869444
  },
  {
    County: 'Uppsala län',
    Latitude: 59.858333,
    Longitude: 17.65
  },
  {
    County: 'Värmlands län',
    Latitude: 59,
    Longitude: 13
  },
  {
    County: 'Västerbottens län',
    Latitude: 64.344722,
    Longitude: 18.314167
  },
  {
    County: 'Västernorrlands län',
    Latitude: 62.733333,
    Longitude: 16.933333
  },
  {
    County: 'Västmanlands län',
    Latitude: 59,
    Longitude: 16
  },
  {
    County: 'Västra Götalands län',
    Latitude: 58.216944,
    Longitude: 11.733333
  },
  {
    County: 'Örebro län',
    Latitude: 59.266667,
    Longitude: 15.216667
  },
  {
    County: 'Östergötlands län',
    Latitude: 58.410556,
    Longitude: 15.613611
  }
]
